import { render } from "./SelectInputConfig.vue?vue&type=template&id=c2124e6a&scoped=true&ts=true"
import script from "./SelectInputConfig.vue?vue&type=script&lang=ts"
export * from "./SelectInputConfig.vue?vue&type=script&lang=ts"

import "./SelectInputConfig.vue?vue&type=style&index=0&id=c2124e6a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2124e6a"]])

export default __exports__